// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2mwsD","list":"BalanceDue_list__1DrnV","listRow":"BalanceDue_listRow__26U7q","total":"BalanceDue_total__3qt6B"};